import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { Leaf } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }
    if (password !== confirm) {
      toast.error("Passwords don't match");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset. Please sign in.");
      navigate("/login");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Reset failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen gradient-hero flex items-center justify-center p-6">
      <Card className="w-full max-w-md rounded-3xl border-emerald-100 p-8">
        <Link to="/" className="flex items-center gap-2 mb-6">
          <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-emerald-400 to-sky-400 flex items-center justify-center">
            <Leaf className="w-5 h-5 text-white" />
          </div>
          <span className="font-display font-bold">NutriGuide</span>
        </Link>
        <h1 className="font-display text-2xl font-bold text-slate-900">Choose a new password</h1>
        {!token && <p className="text-sm text-red-600 mt-2">Missing or invalid token.</p>}
        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="reset-form">
          <div className="space-y-1.5">
            <Label htmlFor="pw">New password</Label>
            <Input id="pw" type="password" required className="rounded-xl h-11" value={password}
                   onChange={(e) => setPassword(e.target.value)} data-testid="reset-password" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="pwc">Confirm password</Label>
            <Input id="pwc" type="password" required className="rounded-xl h-11" value={confirm}
                   onChange={(e) => setConfirm(e.target.value)} data-testid="reset-confirm" />
          </div>
          <Button type="submit" disabled={busy || !token} className="w-full rounded-full h-11 bg-emerald-600 hover:bg-emerald-700" data-testid="reset-submit">
            {busy ? "Updating…" : "Reset password"}
          </Button>
        </form>
      </Card>
    </div>
  );
}
